document.addEventListener("DOMContentLoaded", function () {
  const slides = document.querySelectorAll(".homepage__slider-item");
  const controls = document.querySelector(".homepage__slider-control-panel");
  const dotsLine = document.querySelector(".homepage__slider-slider-dots");

  for (let i = 0; i < slides.length; i++) {
    const dot = document.createElement("div");
    dot.className = "homepage__slider-dots_item";
    dot.setAttribute("data-slide", i + 1);
    dotsLine.appendChild(dot);
  }

  let slideIndex = 1;

  const showSlides = (number) => {
    const dots = document.querySelectorAll(".homepage__slider-dots_item");
    const images = document.querySelectorAll(".homepage__slider-item-image");

    if (number > slides.length) {
      slideIndex = 1;
    }
    if (number < 1) {
      slideIndex = slides.length;
    }

    [...slides].forEach((slide) => {
      slide.classList.add("hidden");
    });

    [...dots].forEach((dot) => {
      dot.classList.remove("active");
    });

    [...images].forEach((img) => {
      img.classList.remove("active");
    });

    slides[slideIndex - 1].classList.remove("hidden");
    images[slideIndex - 1].classList.add("active");
    dots[slideIndex - 1].classList.add("active");
  };

  showSlides(slideIndex);

  const currentSlide = (n) => {
    showSlides((slideIndex = n));
  };

  controls.addEventListener("click", (e) => {
    if (e.target.dataset.action === "prevSlide") {
      showSlides((slideIndex -= 1));
    }

    if (e.target.dataset.action === "nextSlide") {
      showSlides((slideIndex += 1));
    }

    if (e.target.dataset.slide) {
      currentSlide(e.target.dataset.slide);
    }
  });

  function controlsPosition() {
    const bodyWidth = document.querySelector("body").offsetWidth;
    const checkImageHeight = setInterval(() => {
      const imageHeight = document.querySelector(".homepage__slider-item-image.active img").clientHeight;

      if (imageHeight > 0) {
        clearInterval(checkImageHeight);

        const topSpace = bodyWidth > 700 ? (imageHeight * 1.09).toFixed() : (imageHeight + 70).toFixed();
        controls.style.top = topSpace + "px";
      }
    }, 250);
  }

  window.addEventListener("resize", controlsPosition);

  setInterval(() => {
    showSlides((slideIndex += 1));
  }, 5000);

  const popupVideo = document.getElementById("popupVideo");
  function stopVideo() {
    popupVideo.pause();
    popupVideo.currentTime = 0;
  }
  $(".homepage__slider-btn").on("click", function (event) {
    event.preventDefault();
    $(".overlay").fadeIn();
    popupVideo.play();
    return false;
  });
  $(document).click(function (event) {
    if ($(event.target).closest("#popupVideo").length) return;
    $(".overlay").fadeOut(500);
    stopVideo();
    event.stopPropagation();
  });
});
